// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__bT1G1","btnsWrapper":"Header_btnsWrapper__OBtYa","responsibleBtns":"Header_responsibleBtns__V3pga"};